export default __webpack_public_path__ + "static/media/dpay-logo.6090378e.jpeg";